// extracted by mini-css-extract-plugin
export default {"Icon_heading_wrapper":"Login_Icon_heading_wrapper__4kH6u"};